import {combineReducers} from 'redux';
import sessionReducer from "./sessionReducer";
import alertReducer from "./alertReducer";

export default combineReducers({
    sessionState: sessionReducer,
    alertState: alertReducer
});


// WEBPACK FOOTER //
// ./src/redurcers/index.js